import type { Store } from 'redux';
import { storeManager } from './storeManager.ts';

/** Sets the store returned by {@link getStore} */
export function setStore(store: Store) {
  storeManager.store = store;
}